import React from 'react';
import { paymentStatusRows } from '../../data/gtbankUatData';
import Div from '../Div';
import { UatPageShell, UatTable } from './UatDocumentationPage';

const columns = [
  { key: 'refNo', label: 'Ref No' },
  { key: 'initialStatus', label: 'Initial Status' },
  { key: 'currentStatus', label: 'Current Status' },
  { key: 'lastGatewayResponse', label: 'Last Gateway Response' },
  { key: 'updatedAt', label: 'Updated At' },
];

export default function AdminPaymentStatusPage() {
  return (
    <UatPageShell
      title="Payment Status Updates"
      breadcrumb="Payment Status"
      heading="Transaction Status Update"
      subtitle="UAT sample transaction status progression"
    >
      <Div style={{ marginBottom: 22, opacity: 0.82 }}>
        This screen demonstrates how transaction IDs and gateway responses are logged and updated as
        status changes are received.
      </Div>
      <UatTable columns={columns} rows={paymentStatusRows} />
    </UatPageShell>
  );
}
